const features = [
  {
    title: '海量资源',
    desc: '10万+漫画资源覆盖韩漫、日漫、国漫全品类，玄幻、恋爱、热血等类型一应俱全，每日持续上新。',
    icon: 'ri-database-2-line',
    color: 'text-primary-600',
    bg: 'bg-primary-100/80',
  },
  {
    title: '免费阅读',
    desc: '所有漫画完全免费，无需付费订阅。高清画质流畅加载，优质阅读体验零门槛享受。',
    icon: 'ri-vip-crown-line',
    color: 'text-accent-600',
    bg: 'bg-accent-100/80',
  },
  {
    title: '多端适配',
    desc: '完美适配电脑、平板和手机屏幕，支持横屏竖屏自由切换。随时随地打开即读，追更方便快捷。',
    icon: 'ri-device-line',
    color: 'text-secondary-700',
    bg: 'bg-secondary-200/80',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-950 mb-3">平台特色</h2>
          <p className="text-sm text-foreground-500">为什么百万读者选择酷看漫画</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {features.map((item) => (
            <div key={item.title} className="flex flex-col items-center text-center p-6 md:p-8 rounded-2xl bg-background-100">
              <div className={`w-16 h-16 flex items-center justify-center rounded-2xl ${item.bg} ${item.color} mb-4`}>
                <i className={`${item.icon} text-2xl`}></i>
              </div>
              <h3 className="text-lg font-bold text-foreground-800 mb-2">{item.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}